import { Pool } from "./Collections/Pool";
import { NodeList } from "./Collections/NodeList";
import { Node } from "./Collections/Node";



export interface IUpdatableItem {
    release(): IUpdatableItem;
    update(): boolean;
}



/**
 * Spravce aktualizovatelnych polozek.
 */
export class UpdatableItemManager {
    /**
     * Pool s volnymi polozkami
     */
    private _freeItems: Pool<IUpdatableItem>;

    /**
     * (RO) Seznam s aktivnimi polozkami
     */
    get items(): NodeList<IUpdatableItem> { return this._actItems; }
    private _actItems: NodeList<IUpdatableItem>;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(defSize: number, canGrow: boolean, createItemClb: () => IUpdatableItem, createItemClbCtx: any) {
        this._freeItems = new Pool<IUpdatableItem>(undefined, defSize, canGrow, createItemClb, createItemClbCtx);
        this._actItems = new NodeList<IUpdatableItem>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._actItems.forEach((item: IUpdatableItem) => { this._freeItems.returnItem(item.release()); }, this);
        this._actItems.clear();
    }

    //-------------------------------------------------------------------------
    /**
     * Aktivace polozky.
     * @returns Vraci aktivovanou polozku
     */
    //-------------------------------------------------------------------------
    activateItem(): IUpdatableItem {
        let item = this._freeItems.getItem();

        if (item)
            this._actItems.add(item);

        return item;
    }

    //-------------------------------------------------------------------------
    /**
     * Vola metodu update() u aktivnich polozek. Pokud metoda vrati false, tak polozku odstrani ze seznamu aktivnich.
     */
    //-------------------------------------------------------------------------
    update(): void {
        this._actItems.forEach((item: IUpdatableItem, node: Node<IUpdatableItem>) => {
            if (!item.update()) {
                this._freeItems.returnItem(item.release());
                this._actItems.removeByNode(node);
            }
        }, this);
    }
}